<script lang="ts">
	import StoreDetailViewer from "@hitit/hub/src/v7/components/store/StoreDetailViewer.svelte";
	import SalesTransfer from "@hitit/hub/src/v7/components/store/SalesTransfer.svelte";
	import StoreBuisnesshour from "@hitit/hub/src/v7/components/store/StoreBuisenesshour.svelte";
	import StoreOrganization from "../components/store/StoreOrganization.svelte";
	//Utils
	import type { AccessControlDTO, PlaceDTO, StoreData } from "@hitit/api";
	import { api } from "@hitit/hub/src/stores";
	import { onDestroy } from "svelte";
	import { popup } from "../store";

	export let storeId = "";
	export let editable = true;

	enum components {
		BUISNESS_HOUR,
		SALES_TRANSFER,
		STORE_INFOMATION,
		MANAGE_ADMIN,
	}

	const editStatus = {
		[components.BUISNESS_HOUR]: false,
		[components.SALES_TRANSFER]: false,
		[components.STORE_INFOMATION]: false,
		[components.MANAGE_ADMIN]: false,
	};

	const coverStatus = (status: boolean) => {
		const hasEdit = Object.values(editStatus).reduce(
			(prev, cur) => (cur === true ? true : prev),
			false
		);
		return hasEdit && !status;
	};

	let store: StoreData | undefined;
	let place: PlaceDTO | undefined;
	let accessControlDTOs: AccessControlDTO[] | undefined;

	async function loadStore(qStoreId: string) {
		const [storeResponse, placeResponse, storeAccessControlResponse] =
			await Promise.all([
				$api.getStore(qStoreId),
				$api.getPlaceInfomation(qStoreId),
				$api.getAccessControlByStoreId(qStoreId),
			]);

		if (qStoreId !== storeId) return;

		place = placeResponse.data.placeDTO;
		store = storeResponse.data.result.find((v) => v.id === qStoreId);
		accessControlDTOs =
			storeAccessControlResponse.data.accessControlListDTO.accessControlDTOList;
	}

	$: loadStore(storeId);
	onDestroy(() => {
		$popup = undefined;
	});
</script>

<div class="container">
	{#if store && place && accessControlDTOs}
		<div class="head-wrapper">
			<div class="business-hours">
				<div class="flex-height">
					<StoreBuisnesshour
						editable={editable}
						storeId={storeId}
						placeDTO={place}
						coverStatus={coverStatus(editStatus[components.BUISNESS_HOUR])}
						bind:editmode={editStatus[components.BUISNESS_HOUR]}
					/>
				</div>
			</div>
			<div class="sales-transfer">
				<div class="flex-height">
					<SalesTransfer
						editable={editable}
						bind:store={store}
						coverStatus={coverStatus(editStatus[components.SALES_TRANSFER])}
						bind:editmode={editStatus[components.SALES_TRANSFER]}
					/>
				</div>
			</div>
		</div>
		<StoreDetailViewer
			editable={editable}
			bind:store={store}
			coverStatus={coverStatus(editStatus[components.STORE_INFOMATION])}
			bind:editmode={editStatus[components.STORE_INFOMATION]}
		/>
		<StoreOrganization accessControlList={accessControlDTOs} />
	{/if}
</div>

<style lang="scss">
	@import "../../variables.scss";

	div {
		box-sizing: border-box;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 20px;
		width: 100%;
		padding-top: 50px;

		.head-wrapper {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;

			.business-hours {
				display: flex;
				flex-grow: 1;
				min-height: 328px;
			}

			.sales-transfer {
				display: flex;
				flex-grow: 1;
			}
			.flex-height {
				width: 100%;
				flex-grow: 1;
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px;
			padding-top: 0px;
			.head-wrapper {
				flex-direction: row;
				gap: 30px;
				flex-wrap: wrap;

				.business-hours {
					flex-grow: 938;
					min-width: 700px;
					min-height: 268px;
				}
				.sales-transfer {
					width: 546px;
					flex-grow: 626;
					min-width: 546px;
					min-height: 268px;
				}
			}
			:global(.container .action) {
				font-size: 1.25rem;
			}
		}
	}
</style>
